import { Skeleton } from "@/components/ui/skeleton";

export const PolicyCardSkeleton = () => {
  return (
    <div className="bg-white/50 rounded-lg border border-purple-100/50 p-6 shadow-sm animate-pulse">
      <div className="flex justify-between items-start">
        <div className="space-y-4 w-full">
          <Skeleton className="h-6 w-32" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-48" />
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-4 w-44" />
            <Skeleton className="h-4 w-36" />
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-4 w-48" />
          </div>
        </div>
      </div>
    </div>
  );
};